<template>
 <div class="container-fluid">
    <div class="row">
      <sidebar></sidebar>
      <nav-header></nav-header>
      <!-- MAIN CONTENT start -->
      <main role="main" class="col-12 col-sm-9 col-md-10 ml-sm-auto col-lg-10" >
          <breadcrumb :items="pageData.breadcrumb"></breadcrumb>

          <!-- Program -->
          <section class="program-section px-0 mx-0 px-xl-5 mx-xl-5  mt-0 mt-md-5 mb-3">
              <div class="container-fluid px-0 px-sm-3 mx-auto">
    
 

            <h3 class="text-center m-4">{{ $t('psychologist.reserve') }}</h3>    
                <div ref="container" @mousedown.stop>
                <vue-datepicker  
                    v-model="selectedDate"
                    :disabled-date="disabledDate"
                        @calendar-change="onCalendarChange" 
                        @open="onOpen"
                        ref="datepicker"
                        @close="handleClose"
                            :editable="false"
                    :clearable="false"
                    :placeholder="$t('psychologist.chooseDate')"
                    @change="handleDateChange"
                     value-type="date" 
                    />
                </div>

        <div id="timeButtons" class="row justify-content-center" style="margin-top: 30%;">
            <div class="col-2" v-for="time of times"  v-if="times.length>0">
                <button class="btn btn-success p-4 d-block  m-2" @click="reserve(time.ID)">{{ time.start.split('.')[0] }} - {{ time.end.split('.')[0] }}</button>
            </div>
            
 <div class="bg-light b-30 p-4 mb-4 w-100" style="margin-top: 5%;">

    <table v-if="psychologistData.length > 0" class="table-blue-wide w-100" >
      <thead>
      <tr>
        <th>{{ $t('psychologist.date') }}</th>
        <th>{{ $t('psychologist.time') }}</th>
        <th>{{ $t('psychologist.reason') }}</th>
        <th>{{ $t('psychologist.recommendations') }}</th>
        <th>{{ $t('psychologist.room') }}</th>
         
     
      </tr>
      </thead>
      <tbody>
        
        
      <tr    v-for="data of psychologistData">

         

        <td>{{ data.date }}</td>
        <td>{{ data.time }} - {{ data.time_end}}</td>
        <td>{{ data.reason }} </td>
        <td>{{ data.recomendation }}  </td>
        <td> {{$store.state.auth.user?.program_categoryID==1?$t('psychologist.roomDetailge'):$t('psychologist.roomDetailEng') }}  </td>
 
        
        

 
      
      </tr>

  

    
 
      </tbody>
    </table>
     </div>   
</div>
  </div>
          </section>

      </main>
      <!-- MAIN CONTETN end -->
    </div>
  </div>
</template>

<script>
 
import sidebar from '../components/navbar/sidebar';
import appHeader from '../components/app-header';
import pageHeader from '../components/page/page-header';
 
import navHeader from '../components/navbar/nav-header';
import breadcrumb from '../components/page/breadcrumb';
import VueDatepicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import PsychologistResource from  '../api/psychologistResource';
const psychologistResource=new PsychologistResource()
export default {
     name: 'psychologist-consultation',

        data(){

            return{
                selectedDate:null,
                currentYear:null,
                currentMonth:null,
                dayOfWeek:null,
                enabledDaysObj:{
                    year:null,
                    month:null,
                    enabledDayIds:[]

                },
                times:[],
                psychologistData:[],
                fullDate:null
            }

        },

        watch:{

            
        selectedDate(val){

            if(val){
                psychologistResource.getTimes(this.currentYear,this.currentMonth,this.dayOfWeek,val).then(response=>{

                    this.times=response.data

                })
            }

        },


            currentYear(val){
                if(val){

                psychologistResource.getAvailableDates(val,this.currentMonth).then(response=>{

                    let enabledDayIds=[]


                   

                    for(let data of response.data){

                        enabledDayIds.push(data.dayID)

                    this.enabledDaysObj={
                        year:data.year,
                        month:data.month,
                        enabledDayIds:enabledDayIds

                    }
                    

                }


                 })

                }

            },
              currentMonth(val){
                if(val){

                psychologistResource.getAvailableDates(this.currentYear,val).then(response=>{

                    let enabledDayIds=[]


                   

                    for(let data of response.data){

                        enabledDayIds.push(data.dayID)

                    this.enabledDaysObj={
                        year:data.year,
                        month:data.month,
                        enabledDayIds:enabledDayIds

                    }
                    

                }


                 })

                }

            }

           


        },

        mounted(){

              
             this.$refs.datepicker.openPopup()

 
                 
             document.addEventListener('mousedown', this.preventOutsideClose)


            psychologistResource.getPsychologistData().then(response=>{
                    this.psychologistData=response.data
            })  


        },

        beforeDestroy() {
                document.removeEventListener('mousedown', this.preventOutsideClose)
            },
       
          methods: {
              handleDateChange(date) {
                this.dayOfWeek=date.getDay()
              },

                handleClose(){
                   this.$nextTick(() => {
                    this.$refs.datepicker.openPopup()
                })    
                },

                preventOutsideClose(e) {
                    const container = this.$refs.container
                    if (!container.contains(e.target)) {
                        e.stopPropagation()
                        
                        this.$refs.picker.openPopup()
                    }
                    },

                onCalendarChange(viewDate) {
                    this.currentYear = viewDate.getFullYear();
                    this.currentMonth = viewDate.getMonth()+1;  

 
                    },


                    onOpen(){
                          this.$nextTick(() => {
                           
                      
                            const dp = this.$refs.datepicker;


                           

                            const panelDate = dp && dp.currentValue && !isNaN(Date.parse(dp.currentValue))
                            ? new Date(dp.currentValue)
                            : new Date();

                            this.currentYear = panelDate.getFullYear();
                            this.currentMonth = panelDate.getMonth()+1;

                             
                         });
                    },
                
                    disabledDate(date) {
                        

                        if(this.enabledDaysObj.year && this.enabledDaysObj.month){

                                  const today = new Date();
                                  today.setHours(0, 0, 0, 0);
                                  if (date < today) {
                                      return true;
                                  }
                          

                            let month=date.getMonth()+1
                     
                        if (date.getFullYear() == this.enabledDaysObj.year &&  month == this.enabledDaysObj.month) {

                                    

 

                           
                       if(this.enabledDaysObj.enabledDayIds.includes(date.getDay().toString())){
                            return false
                       }
                            
                                
                        }
                       
                        
                    }
                    return true;
                },
              isValidGeorgianPhone(number) {
                return /^5\d{8}$/.test(number);
            },


                reserve(timeID){
                    

                    var reason=prompt(this.$t('psychologist.writereason'))
                   

                    if((!reason && reason!==null)){
                        this.reserve(timeID)
                      
                      return
                    }
                     if(reason){

                       var phone_number=prompt(this.$t('psychologist.phone_number'))
                          if((!phone_number && phone_number!==null)){
                        this.reserve(timeID)
                      
                      return
                    }

                       if(phone_number){
 

                           
                            if(!this.isValidGeorgianPhone(phone_number.toString())){
                                 alert(this.$t('psychologist.phoneIsNotValid'))
                                   this.reserve(timeID)
                                 return 
                            }
                         




                    if(confirm(this.$t('psychologist.confirmation'))){
                      const date = new Date(this.selectedDate);
                      const formatted = date.getFullYear() + '-' +
                 String(date.getMonth() + 1).padStart(2, '0') + '-' +
                 String(date.getDate()).padStart(2, '0');
                     
                    psychologistResource.reserve(timeID,formatted,reason,phone_number).then(()=>{
                         location.reload()
                    }).catch(err=>{

                        if(!err.response.data){
                          alert(this.$t('psychologist.alreadyReserved'))
                        }

                    })

                }
               }
              }
               
                }



  },

  components: {  sidebar, appHeader, pageHeader,  navHeader, breadcrumb,VueDatepicker },
    computed: {
    pageData() {
      return {
        title: this.$t('psychologist.title'),
        breadcrumb: [{
          icon: '',
          title: this.$t('home.title'),
          link: '/',
          isActive: false,
        },
          {
          icon: '',
          title: this.$t('psychologist.title'),
          link: '/psychologist-consultation',
          isActive: true,
        }],
      };
    },
    
  },
 
};
</script>
<style lang="scss" scoped>
  .table-blue-wide td a {
    color: #557c84;
  }
 .mx-datepicker{
    display: block !important;
    margin: 0px auto;
    width: 250px !important;
 }
 @media screen and (max-width:1300px) {
 
  #timeButtons{
    margin-top: 50% !important;
  }
  
 }

  @media screen and (max-width:772px) {
 
  #timeButtons{
    margin-top: 70% !important;
  }
  
 }

   @media screen and (max-width:616px) {
 
  #timeButtons{
    margin-top: 90% !important;
  }
  
 }

  @media screen and (max-width:321px) {
 
  #timeButtons{
    margin-top: 100% !important;
  }
  
 }
 
 
</style>